import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteWorkspaceImage } from "api/services/workspace-service";
import { getWorkspaceImageQueryKey } from "hooks/workspaceImage/queryKeys";

export const useDeleteWorkspaceImage = (workspaceId: string) => {
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async (): Promise<void> => {
            await deleteWorkspaceImage({ workspaceId });
        },
        onSuccess: () => {
            queryClient.setQueryData<Blob | null>(getWorkspaceImageQueryKey(workspaceId), null);
        },
    });

    return {
        deleteWorkspaceImage: mutation.mutateAsync,
        deletingWorkspaceImage: mutation.isPending,
    };
};
